module.exports = __webpack_public_path__ + "img/F6.2b6008ec.png";